<sd-4-5-1-icon
  library="system"
  name="warning"></sd-4-5-1-icon>
<div>
  {{ errorMessage }}
</div>
